import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { Config, IConfigService, ITelemetryService } from '../interfaces';
import { FrameContexts } from '../messages.interface';
import { BaseMessageHandler } from './base-message-handler';
import { onStatusError } from './messageHandlingUtils';
/**
 * Responsible for Page.config module related message requests.
 */
export class PageConfigMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected configService?: IConfigService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    if (this.appSdkHost.getFrameContext() === FrameContexts.settings && !this.configService) {
      throw new Error('Config Service needs to be implemented when in settings frame context');
    }

    this.registerHandler(SdkMessageTypes.pages.config.getConfig, (_) => this.configService!.getConfig());
    this.registerHandler(
      SdkMessageTypes.pages.config.setConfig,
      (_, params: Config) => this.configService!.setConfig(params),
      {
        errorCallback: (error, scenario) => onStatusError(SdkMessageTypes.pages.config.setConfig, error, scenario),
      }
    );
    this.registerHandler(SdkMessageTypes.pages.config.setValidityState, (_, params: boolean) =>
      this.configService!.setValidityState(params)
    );
    this.registerHandler(SdkMessageTypes.pages.config.save.success, (_) => this.configService!.onSaveSuccess());
    this.registerHandler(SdkMessageTypes.pages.config.save.failure, (_, params?: string) =>
      this.configService!.onSaveFailure(params)
    );
    this.registerHandler(SdkMessageTypes.pages.config.remove.success, (_) => this.configService!.onRemoveSuccess());
    this.registerHandler(SdkMessageTypes.pages.config.remove.failure, (_, params?: string) =>
      this.configService!.onRemoveFailure(params)
    );
  }

  protected validateDependencies() {
    if (!this.configService) {
      throw 'No configService provided';
    }
  }
}
